(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[28967],{

/***/ 77472:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/phongvu/desktop/products/[sku]",
      function () {
        return __webpack_require__(548414);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 548414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var tenants_phongvu_desktop_products_sku___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(945656);
// AUTO GENERATED FILE. DO NOT EDIT.

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (tenants_phongvu_desktop_products_sku___WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);


/***/ }),

/***/ 953067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useCustomPromotion; }
/* harmony export */ });
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(788813);
/* harmony import */ var services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(268711);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(859676);



const useCustomPromotion = ()=>{
    const { data  } = (0,swr__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)([
        "/magento/customdata/custom_promo_text",
        "custom_promo_text"
    ], (_url, code)=>{
        return services__WEBPACK_IMPORTED_MODULE_1__/* .magentoService.getCustomData */ .c.getCustomData(code).then((res)=>{
            var ref;
            return Object.values(((ref = res.data) === null || ref === void 0 ? void 0 : ref.data) || {}).map((promotion)=>(0,helpers__WEBPACK_IMPORTED_MODULE_2__/* .transformExtraPromotion */ .Y2)(promotion)).filter((promotion)=>promotion.date && (0,helpers__WEBPACK_IMPORTED_MODULE_2__/* .checkExpiryDate */ .N6)(promotion.date.startDate, promotion.date.endDate));
        });
    }, {
        revalidateOnFocus: false
    });
    return {
        customPromotions: data || []
    };
};


/***/ }),

/***/ 945656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getServerSideProps */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(534924);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(393957);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(115674);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(684443);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85470);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
/* harmony import */ var types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(857387);
/* harmony import */ var _module_hooks_useCustomPromotions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(953067);









const NewDetailPage = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(27953), __webpack_require__.e(19303), __webpack_require__.e(90400), __webpack_require__.e(29078), __webpack_require__.e(4545), __webpack_require__.e(76414), __webpack_require__.e(22295), __webpack_require__.e(48962), __webpack_require__.e(85541), __webpack_require__.e(55679), __webpack_require__.e(22859), __webpack_require__.e(2026), __webpack_require__.e(92658), __webpack_require__.e(84261), __webpack_require__.e(52136), __webpack_require__.e(65243), __webpack_require__.e(55050), __webpack_require__.e(15292), __webpack_require__.e(74668), __webpack_require__.e(5974), __webpack_require__.e(25260), __webpack_require__.e(37732), __webpack_require__.e(99154)]).then(__webpack_require__.bind(__webpack_require__, 499154)).then((mod)=>mod.NewDetailPage), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(499154)
            ]
    }
});
const DetailPage = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(27953), __webpack_require__.e(19303), __webpack_require__.e(90400), __webpack_require__.e(29078), __webpack_require__.e(4545), __webpack_require__.e(76414), __webpack_require__.e(22295), __webpack_require__.e(48962), __webpack_require__.e(85541), __webpack_require__.e(55679), __webpack_require__.e(22859), __webpack_require__.e(2026), __webpack_require__.e(92658), __webpack_require__.e(84261), __webpack_require__.e(52136), __webpack_require__.e(65243), __webpack_require__.e(55050), __webpack_require__.e(15292), __webpack_require__.e(74668), __webpack_require__.e(5974), __webpack_require__.e(25260), __webpack_require__.e(37732), __webpack_require__.e(99154)]).then(__webpack_require__.bind(__webpack_require__, 499154)).then((mod)=>mod.DetailPage), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(499154)
            ]
    }
});
const ProductDetails = ()=>{
    const { vnpayPromotions  } = (0,hooks__WEBPACK_IMPORTED_MODULE_3__/* .useVnpayPromotion */ .h)("phongvu_vnpay_promotion");
    const { customPromotions  } = (0,_module_hooks_useCustomPromotions__WEBPACK_IMPORTED_MODULE_4__/* .useCustomPromotion */ .f)();
    const { epicOmni1643  } = (0,hooks__WEBPACK_IMPORTED_MODULE_5__/* .useTenantConfig */ .Wx)();
    const extraPromotions = (0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .formatExtraPromotions */ .E)(vnpayPromotions, types__WEBPACK_IMPORTED_MODULE_7__/* .PROMOTION_TYPE.magento */ .j.magento);
    const extraCustomPromotions = (0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .formatExtraPromotions */ .E)(customPromotions, types__WEBPACK_IMPORTED_MODULE_7__/* .PROMOTION_TYPE.customMagento */ .j.customMagento);
    if (epicOmni1643) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NewDetailPage, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DetailPage, {
        extraPromotions: [
            ...extraPromotions,
            ...extraCustomPromotions
        ]
    });
};
const ProductDetailsPage = (param)=>{
    let { serverProduct , inlineBanners  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(contexts__WEBPACK_IMPORTED_MODULE_8__/* .ProductDetailProvider */ .D, {
        serverProduct: serverProduct,
        inlineBanners: inlineBanners,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductDetails, {})
    });
};
const getServerSideProps = (/* unused pure expression or super */ null && (getServerSidePropsDetail));
/* harmony default export */ __webpack_exports__["Z"] = (ProductDetailsPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [88837,34924,3830,93712,49774,92888,40179], function() { return __webpack_exec__(77472); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);